module.exports = __webpack_public_path__ + "static/media/Delivery Truck.10a0f92b.png";